const setCustomer = (state, customer) => { state.customer = customer; };

const setError = (state, error) => { state.error = error; };

const setPasswordError = (state, error) => { state.passwordError = error; };

const setPasswordLoading = (state, loading) => { state.passwordLoading = loading; };

export default {
  setCustomer,
  setError,
  setPasswordError,
  setPasswordLoading,
};
